import { Box } from "@mui/system";
import React, { Component } from 'react';
import { Typography, Divider, CardContent, CircularProgress } from "@mui/material";
import {
    PieChart,
    Pie,
    Cell,
    Label,
    ResponsiveContainer,
} from "recharts";
import theme from "../styles/customTheme";
import Slider from '@mui/material/Slider';
import RightArrow from "../images/right-arrow.svg";
import treeImage from "../images/tree.png";
import axios from "axios";
import { getURLBase } from "../utils/helperFns";
import wyzrTheme from "../styles/customTheme";


export class CarbonFootprintCategories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            sliderMarks:  [],
            total: 0,
            piedata: [],
            showTreeInPie: false,
            value: 0,
            default: 0
        };
    }
    componentDidMount() {
        axios.post(getURLBase(true) + '/cfcategories', { gid: this.props.gid } ).then(res => {

            res.data.body.data.forEach(element => {
                element.piedata.push({
                    img: "donotdisplay",
                    value: 1,
                    label: "Kg"
                })

            });

            this.setState({
                total: res.data?.body?.data[0]?.total,
                piedata: res.data.body.data[0].piedata ? res.data.body.data[0].piedata : [],
                value: res.data.body.data[0].value,
                sliderMarks: res.data.body.data,
                isReady: true
            })
        })
    }
    COLORS = [theme.palette.grey[300], theme.palette.grey[400], theme.palette.grey[500], theme.palette.grey[600], theme.palette.grey[700], theme.palette.grey[800]];
    renderCustomizedLabel = ({
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        value,
        img,
        label
    }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 2.6;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);
        const fx = x;
        const fy = y;
        return (
            <g>
                <svg >
                { 
                        img !== "donotdisplay" ? (
                    <image text-anchor="middle" x={fx - 12} y={fy - 25}
                        href={`/cf_categories/${img}.svg`} height="1.6rem" width="2rem" />
                ) : null
                }
                
                    <text
                        x={fx + 30} y={fy - 25}
                        fill="black"
                        className="recharts-text recharts-label"
                        dominantBaseline="central"
                    >
                        { 
                        img !== "donotdisplay" ? (
                            <>
                            <tspan text-anchor="middle" x={fx} y={fy + 10} style={{
                            fontSize: "0.8rem",
                            fontWeight: "700",
                            fontFamily: "Nunito Sans",
                        }}>{value}</tspan>
                        <tspan text-anchor="middle" x={fx} dy={16} y={fy + 10} style={{
                            fontSize: "0.8rem",
                            fontWeight: "700",
                            fontFamily: "Nunito Sans",
                        }}>{label.replace(value, '')} CO2</tspan></>
                        ): null
                        }
                        
                    </text>
                </svg>
            </g>
        );
    };
    toggleCenterText = () => {
        var s = this.state;
        s.showTreeInPie = !s.showTreeInPie;
        this.setState({ s });
    };
    CenterLabel = ({ viewBox, amount = 0 }) => {
        const { cx, cy } = viewBox;
        return (
            <React.Fragment >
                {!this.state.showTreeInPie ?
                    <g onClick={this.toggleCenterText} style={{ cursor: "pointer" }}>
                        <text x={cx} y={cy} textAnchor="middle">
                            <tspan
                                className='chart-label'
                                style={{
                                    fontSize: "1.5rem",
                                    fontWeight: "800",
                                }}
                            >
                                {this.state.total}
                            </tspan>
                        </text>
                        <text x={cx} y={cy + 30} textAnchor="middle">
                            <tspan
                                fill={wyzrTheme.palette.grey[800]}
                                className='chart-label'
                                style={{
                                    fontSize: "1.2rem",
                                    fontWeight: "600",
                                }}
                            >
                                CO₂
                            </tspan>
                        </text>
                        <image href={RightArrow} height={20} width={20} x={cx + 50} y={cy - 10}></image>
                    </g>
                    :
                    <g onClick={this.toggleCenterText} style={{ cursor: "pointer" }}>
                        <image href={treeImage} height={50} width={50} x={cx - 22} y={cy - 50} ></image>
                        <text x={cx} y={cy + 15} textAnchor="middle">
                            <tspan
                                className='chart-label'
                                style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "600",
                                }}
                            >
                                0.38 of a tree
                            </tspan>
                        </text>
                        <text x={cx} y={cy + 22} textAnchor="middle">
                            <tspan
                                className='chart-label'
                                dy={10}
                                style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "600",
                                }}
                            >
                                absorbs this carbon
                            </tspan>
                        </text>
                        <text x={cx} y={cy + 49} textAnchor="middle">
                            <tspan
                                className='chart-label'
                                style={{
                                    fontSize: "0.9rem",
                                    fontWeight: "600",
                                }}
                            >
                                in its lifetime
                            </tspan>
                        </text>

                        <image href={RightArrow} height={20} width={20} x={cx + 50} y={cy - 10}></image>
                    </g>
                }
            </React.Fragment>
        );
    };

    handlePieData = (value) => {
        console.log(this.state.sliderMarks)
        this?.state?.sliderMarks?.map(item => {
            if (item.value === value) {
                this.setState({
                    value: item.value,
                    piedata: item.piedata,
                    total: item.total,
                })
            }
        })
    }

    valueLabelFormat = (value) => {
        return this.state.sliderMarks.findIndex((mark) => mark.value === value) + 1;
    }
    render() {
        return (
            <Box className={"widgetCard cardShadow"} >
                <Typography variant="h4" gutterBottom align="center">
                    Categories
                </Typography>
                <Divider light />
                <CardContent className={`${this.state.isReady ? (`${(this.state.total === null || this.state.total === 0) ? "blur" : ""}`) : ""}`}>
                    <Box className="categories-piechart" mt={1}  >
                        <ResponsiveContainer width="100%" height={300} className={!this.state.value || this.state.value === 0 ? "blur": ""}>
                            <PieChart width="100%" height="100%">
                                <Pie
                                    data={this.state.piedata}
                                    label={this.renderCustomizedLabel}
                                    labelLine={false}
                                    outerRadius="70%"
                                    innerRadius="55%"
                                    fill="#8884D8"
                                    paddingAngle={0}
                                    dataKey="value"
                                    verticalAlign="center"
                                    startAngle={180}
                                    endAngle={-180}
                                >  <Label
                                        content={<this.CenterLabel amount={this.state.total} />}
                                        position="center"
                                    />
                                    {this?.state?.piedata?.map((entry, index) => (
                                        <Cell key={`budCat-${index}`} fill={this.COLORS[index]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </Box>
                    <Box maxWidth={420} marginTop={2} marginX="auto">
                        {this.state.isReady ? <Slider
                            aria-label="Restricted values"
                            defaultValue={this.state.value}
                            onChangeCommitted={(e, value) => this.handlePieData(value)}
                            valueLabelFormat={this.valueLabelFormat}
                            step={null}
                            valueLabelDisplay="auto"
                            marks={this.state.sliderMarks}
                            data-index={this.valueLabelFormat}
                            min={0}
                            max={365}
                            size="medium"
                        /> : <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "20vh" }}><CircularProgress color="success" /></Box>}
                    </Box>
                </CardContent>
            </Box>
        );
    }
}
export default CarbonFootprintCategories